import {Component, EventEmitter, Input, model, Output, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgbDate, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import {Moment} from 'moment';
import {DayOfWeek} from '../../../classes/enums/DayOfWeek';
import {DayOfWeekParsePipe, dayOfWeekParse} from '../../../pipes/day-of-week-parse.pipe';

/**
 * This component handles displaying and editing a date, using template driven forms.
 */
@Component({
  selector: 'app-input-date',
  templateUrl: './input-date.component.html',
  styleUrls: ['./input-date.component.less'],
  imports: [CommonModule, FormsModule, NgbModule]
})
export class InputDateComponent {

  /** A text string, which is displayed in an input field as a hint, what information a user needs to enter. */
  readonly placeholder = input<string>(undefined);
  /** An identifier of an input HTML element. */
  readonly name = input<string>(undefined);
  /** A date value, which will be edited in the form. */
  inputDate = model<string>();
  /** `True`, if only Mondays are allowed to be selected as an {@link inputDate}. */
  @Input() onlyMondays: boolean;
  /** `True`, if only Sundays are allowed to be selected as an {@link inputDate}. */
  @Input() onlySundays: boolean;
  /** The first date, from which {@link inputDate} is allowed to be selected. */
  @Input() editDate: string;
  /** `True` if any input is currently disabled. */
  readonly isDisabled = input<boolean>(undefined);
  /** An event to return selected input date to a parent component. */

  /**
   * Checks if a date is not allowed to be selected.
   * @param date a date, which might be disabled to select.
   */
  isDisabledDate = (date: NgbDate) => {
    if (!date) {
      return false;
    }
    const editDate = this.editDate ? moment(this.editDate) : moment();
    const day = this.toMoment(date);
    return day.isBefore(editDate)
            || this.onlyMondays && day.format('ddd') !== dayOfWeekParse(DayOfWeek.MONDAY)
            || this.onlySundays && day.format('ddd') !== dayOfWeekParse(DayOfWeek.SUNDAY);
  }

  /**
   * Converts a date as {@link NgbDateStruct} to {@link Moment}.
   * @param date a date as {@link NgbDateStruct}.
   */
  toMoment(date: NgbDateStruct): Moment {
    if (!date) {
      return;
    }
    return moment(date.year + '-' + date.month + '-' + date.day, 'YYYY-MM-DD');
  }
}
